import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function BrandSection() {
  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    infinite: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 777, settings: { slidesToShow: 3 } },
      { breakpoint: 575, settings: { slidesToShow: 2 } },
      { breakpoint: 400, settings: { slidesToShow: 1 } },
    ],
  };

  const brandLogos = [
    { src: "images/British.png", alt: "British Eagle" },
    { src: "images/CG.png", alt: "Crazy Girl" },
    { src: "images/LMF.png", alt: "LMF" },
    { src: "images/WSO.png", alt: "Whole Sale" },
    { src: "images/KO.png", alt: "KO Trading" },
    { src: "images/British.png", alt: "British Eagle" },
    { src: "images/CG.png", alt: "Crazy Girl" },
    { src: "images/LMF.png", alt: "LMF" },
    { src: "images/WSO.png", alt: "Whole Sale" },
    { src: "images/KO.png", alt: "KO Trading" },
  ];

  return (
    <>
      <div className="row">
  <div className="col-lg-12">
    {/* section-title */}
    <div className="section-title title-style-center_text">
      <div className="title-header">
        {/* <h3>OUR CLIENTS</h3> */}
        <h2 className="title">OUR <b>CLIENTS</b></h2>
      </div>
    </div>{/* section-title end */}
  </div>
</div>
    <section className="ttm-row client-section ttm-bgcolor-grey clearfix">
      <div className="container">
        <Slider {...settings}>
          {brandLogos.map((logo, index) => (
            <div key={index} className="client-box">
              <div className="ttm-client-logo-tooltip" data-tooltip={logo.alt}>
                <div className="client-thumbnail">
                  <img
                    className="img-fluid auto_size"
                    width={160}
                    height={98}
                    src={logo.src}
                    alt={logo.alt}
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
    
    </>
  );
}

export default BrandSection;
